<template>
  <div class="school-finder">
    <div class="card-top">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <Conditions-cx-vue
      :conditionsExt="conditionsExt"
      :artSchool="artSchools"
      :temp-zxkm = "tempZxkm"
      ref="son"
    />
  </div>
</template>

<script>
import { conditionsExt } from "../../common/Conditions";
import { mapState } from "vuex";
import ConditionsCxVue from '../../components/ysh/Conditions-cx.vue';
export default {
  name: "SchoolFinder",
  data() {
    return {
      conditionsExt: conditionsExt,
      artSchools: {
        pageNum: 1,
        items: [], //院校属地
        plan: {
          sxkm: "",
          lkxk: 0
        },
        yxmc: "", //院校名称
        type: 0
      },
      tempZxkm: [] // 再选科目选中项
    };
  },
  beforeRouteUpdate(to,from,next){
    console.log(to,next);
  },
  components: {
    ConditionsCxVue
  },
  computed: {
    ...mapState(["userInfo"])
  },
  // 接收注入的数据
  watch: {
    $route(to, from) {
      console.log(to,from);
      if (
        (to.path === "/main/yshSchoolRecommend" || to.path === "/main/yshSchoolFinder") &&
        (from.path === "/main/yshSchoolRecommend" || from.path === "/main/yshSchoolFinder")
      ) {
        // this.$store.dispatch("RestSchoolData");
        this.$store.commit("initSchool");
        this._innerMap(this.conditionsExt.yxdq);
        this._innerMap(this.conditionsExt.pcType);
        this._innerMap(this.conditionsExt.rkcj);
        this._innerMap(this.conditionsExt.yxType);
        this._innerMap(this.conditionsExt.type);
        this._innerMap(this.conditionsExt.zxkms);
        this.artSchools = {
          pageNum: 1,
          items: [], //院校属地
          plan: { sxkm: this.userInfo.sxkm, lkxk: 0 },
          yxmc: "", //院校名称
          type: "",
        };
        this.tempZxkm = []
      }
      if (to.path === "/main/yshSchoolRecommend" && this.artSchools.type === "") {
        this.artSchools.type = 1;
        this._initPc();
      } else if (to.path === "/main/yshSchoolFinder" && this.artSchools.type === "") {
        this.artSchools.type = 0;
        this._innerMap(this.conditionsExt.pcType);
        delete this.artSchools.condition;
      }
      if (to.path === "/main/yshSchoolRecommend") {
        this.$refs.son.flag = false;
        this._initPc();
      } else if (to.path === "/main/yshSchoolFinder") {
        this.artSchools.type = 0;
      }
    }
  },

  methods: {
    _innerMap(item) {
      item.map((innerItem, index) => {
        if (index === 0) {
          innerItem.isActive = true;
        } else {
          innerItem.isActive = false;
        }
      });
    },
    _initPc() {
      if (this.userInfo.pc === "本科提前批") {
        this.conditionsExt.pcType.map((pcItem, i) => {
          // "本科提前批平行组院校"
          if (pcItem.name === "本科提前批") {
            pcItem.isActive = true;
            this.artSchools.condition = pcItem.value;
          } else {
            pcItem.isActive = false;
          }
        });
        // 本科批平行组院校
      } else if (this.userInfo.pc === "本科批") {
        this.conditionsExt.pcType.map((pcItem, i) => {
          if (pcItem.name === "本科提前批") {
            pcItem.isActive = true;
            this.artSchools.condition = pcItem.value;
          } else {
            pcItem.isActive = false;
          }
        });
        // 本科三批
      } else if (this.userInfo.pc === "本科三批") {
        this.conditionsExt.pcType.map((pcItem, i) => {
          if (pcItem.name === "本科提前批") {
            pcItem.isActive = true;
            this.artSchools.condition = pcItem.value;
          } else {
            pcItem.isActive = false;
          }
        });
      } else if (this.userInfo.pc === "专科提前批") {
        this.conditionsExt.pcType.map((pcItem, i) => {
          if (pcItem.name === "专科提前批") {
            pcItem.isActive = true;
            this.artSchools.condition = pcItem.value;
          } else {
            pcItem.isActive = false;
          }
        });
      } else if (this.userInfo.pc === "高职专科批") {
        this.conditionsExt.pcType.map((pcItem, i) => {
          if (pcItem.name === "高职专科批") {
            pcItem.isActive = true;
            this.artSchools.condition = pcItem.value;
          } else {
            pcItem.isActive = false;
          }
        });
      }else if(this.userInfo.pc===null){
       this.conditionsExt.pcType.map((pcItem, i) => {
          if (pcItem.name === "本科提前批") {
            pcItem.isActive = true;
            this.artSchools.condition = pcItem.value;
          } else {
            pcItem.isActive = false;
          }
        });
      }
    },
    _initPc2() {
      this.conditionsExt.pcType.map((pcItem, i) => {
          // "本科提前批平行组院校"
          if (i===0) {
            pcItem.isActive = true;
            this.artSchools.condition = pcItem.value;
          } else {
            pcItem.isActive = false;
          }
        });
    },
    //根据用户注册显示可选科类
    _switchKlAndpcType() {
      if (this.userInfo) {
        this.artSchools.plan.sxkm = this.userInfo.sxkm;
      }
    },
  },
  mounted() {
    this._switchKlAndpcType();
    if (this.$route.path === "/main/yshSchoolRecommend") {
        const typeArr=this.conditionsExt.type;
        let lx1=1;
        for(let i=0;i<typeArr.length;i++){
          if(typeArr[i].isActive){
            lx1=typeArr[i].value;
          }
        }
      this.artSchools.type = lx1;
      this._initPc();
    }else if(this.$route.path==="/main/yshSchoolFinder"){
      this._initPc2();
    }
    this.$router.beforeEach((to, from, next) => {
      // 在这里处理路由变化的逻辑
      // to：即将进入的路由对象
      // from：当前导航正要离开的路由对象
      // next：调用该方法后，才能进入下一个钩子
      // 例如，可以在这里发送请求，加载数据等
      if (
        (to.path === "/main/yshSchoolRecommend" || to.path === "/main/yshSchoolFinder") &&
        (from.path === "/main/yshSchoolRecommend" || from.path === "/main/yshSchoolFinder")||
        (from.path === "/main/yshMajorQuery" || from.path === "/main/yshMe/updateScore"||
        from.path==="/main/yshMe/updatePwd"||from.path==="/main/yshMe/collectSchool"||
        from.path==="/main/yshDataHome")
      ) {
        // this.$store.dispatch("RestSchoolData");
        this.$store.commit("initSchool");
        this._innerMap(this.conditionsExt.yxdq);
        this._innerMap(this.conditionsExt.pcType);
        this._innerMap(this.conditionsExt.rkcj);
        this._innerMap(this.conditionsExt.yxType);
        this._innerMap(this.conditionsExt.type);
        this._innerMap(this.conditionsExt.zxkms);
        this.artSchools = {
          pageNum: 1,
          items: [], //院校属地
          plan: { sxkm: this.userInfo.sxkm, lkxk: 0 },
          yxmc: "", //院校名称
          type: "",
        };
        this.tempZxkm = []
      }
      if (to.path === "/main/yshSchoolRecommend" && this.artSchools.type === "") {
        this.artSchools.type = 1;
        this._initPc();
      } else if (to.path === "/main/yshSchoolFinder" && this.artSchools.type === "") {
        this.artSchools.type = 0;
        this._innerMap(this.conditionsExt.pcType);
        delete this.artSchools.condition;
      }
      if (to.path === "/main/yshSchoolRecommend") {
        // this.$refs.son.flag = false;
        this._initPc();
      } else if (to.path === "/main/yshSchoolFinder") {
        this.artSchools.type = 0;
      }
      next();
    });
  }
};
</script>

<style lang="stylus" scoped>
.school-finder
    min-width 1200px
    margin 0 auto
    min-height calc(100vh - 380px)
    min-height -moz-calc(100vh - 380px)
    min-height -webkit-calc(100vh - 380px)
    .card-top
        width 1100px
        margin 20px auto
</style>
